import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useSelector } from 'react-redux';
import config from 'constants/apiConfig';
import { selectGroupGuid, selectUserGuid } from 'slices/commonSelectors';

import { keys as resourceSetKeys } from './resourceSetHooks';
import { toast } from 'react-toastify';
export const useBulkCreateResources = () => {
  const group_guid = useSelector(selectGroupGuid);
  const queryClient = useQueryClient();
  const user_guid = useSelector(selectUserGuid);

  return useMutation({
    mutationFn: async (template: File) => {
      const formData = new FormData();
      formData.append('template', template);
      formData.append('group', group_guid);

      return await axios.post(
        `${config.apiGateway.ics_bulk_resources}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
    },
    onSuccess: (result) => {
      if (result?.data?.success === false && result?.data?.message) {
        toast.warning(result.data.message);
        return;
      } else {
        toast.success(result?.data?.message);
      }
      queryClient.invalidateQueries({
        queryKey: resourceSetKeys.list(group_guid, user_guid),
      });
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
};
